import type { DemoFamily } from 'app/types/related-contacts'

export const DEMO_FAMILIES: readonly DemoFamily[] = [
  {
    id: `moreno`,
    story: `Linda called about her husband and both kids. She owns the number, so she is the primary contact.`,
    primary: {
      id: `linda`,
      name: `Linda Moreno`,
      phone: `(555) 010-2231`,
      age: 41,
      openTreatment: 0,
      ownNumber: true,
      reason: `phone owner`,
    },
    members: [
      {
        id: `jake`,
        name: `Jake Moreno`,
        age: 12,
        relationship: `son`,
        leadStatus: `In Progress`,
        nextAction: `Call back today`,
        openTreatment: 1840,
        ownNumber: false,
        hygieneDue: true,
      },
      {
        id: `ava`,
        name: `Ava Moreno`,
        age: 9,
        relationship: `daughter`,
        leadStatus: `Needs Action`,
        nextAction: `Book first visit`,
        openTreatment: 0,
        ownNumber: false,
        hygieneDue: true,
      },
      {
        id: `mark`,
        name: `Mark Moreno`,
        phone: `(555) 010-4410`,
        age: 44,
        relationship: `husband`,
        leadStatus: `Scheduled`,
        openTreatment: 0,
        ownNumber: true,
      },
    ],
  },
  {
    id: `parker`,
    story: `Ethan is the lead with open treatment, but his mom Diane is the guarantor and the person staff talk to.`,
    primary: {
      id: `diane`,
      name: `Diane Parker`,
      phone: `(555) 010-8812`,
      age: 47,
      openTreatment: 0,
      ownNumber: true,
      reason: `guarantor`,
    },
    members: [
      {
        id: `ethan`,
        name: `Ethan Parker`,
        age: 16,
        relationship: `son`,
        leadStatus: `In Progress`,
        nextAction: `Send treatment estimate`,
        openTreatment: 4250,
        ownNumber: false,
        hygieneDue: true,
      },
    ],
  },
  {
    id: `okafor`,
    story: `Grace is 22 with her own cell, so she is texted directly. She still shows in her father's family.`,
    primary: {
      id: `james`,
      name: `James Okafor`,
      phone: `(555) 010-3390`,
      age: 55,
      openTreatment: 0,
      ownNumber: true,
      reason: `guarantor`,
    },
    members: [
      {
        id: `grace`,
        name: `Grace Okafor`,
        phone: `(555) 010-6627`,
        age: 22,
        relationship: `daughter`,
        leadStatus: `Needs Action`,
        nextAction: `Call back`,
        openTreatment: 620,
        ownNumber: true,
        hygieneDue: true,
      },
    ],
  },
  {
    id: `kim`,
    story: `Noah is 15 and no adult is linked yet, so nothing can be sent until staff link one.`,
    members: [
      {
        id: `noah`,
        name: `Noah Kim`,
        phone: `(555) 010-1174`,
        age: 15,
        leadStatus: `Needs Action`,
        nextAction: `Find a parent or guardian`,
        openTreatment: 0,
        ownNumber: true,
        hygieneDue: true,
      },
    ],
  },
  {
    id: `ortiz`,
    story: `Sam is an adult who called about himself: a family of one, exactly like today.`,
    primary: {
      id: `sam`,
      name: `Sam Ortiz`,
      phone: `(555) 010-7781`,
      age: 34,
      leadStatus: `Needs Action`,
      nextAction: `Send forms`,
      openTreatment: 0,
      ownNumber: true,
      reason: `phone owner`,
    },
    members: [],
  },
]
